// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2k0RL","toggle":"styles_toggle__P79oR","preview":"styles_preview__1i2G5"};